import React from 'react';
import { Row, Col, Card, Table, Alert } from 'react-bootstrap';
import PagedRows from './PagedRows';

const money = (n) => new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' }).format(n || 0);
const pct = (n) => n == null ? '—' : `${n.toFixed(1)}%`;

const GastosTab = ({ expensesSummary, expensesByCategory, profitMargin, profitLoss }) => (
  <div className="mt-3">
    <Alert variant="warning" className="mb-3">
      Este Estado de Resultados es simplificado (base caja, sin depreciación ni acumulaciones) y el costo de producto
      usa el costo <strong>actual</strong> cargado en Productos — no un costo histórico al momento de cada venta. Es una
      guía direccional, no un cierre contable formal.
    </Alert>

    <Row className="mb-3">
      <Col md={4}>
        <Card className="shadow-sm p-3 dashboard-card">
          <div className="text-muted small">Ingresos (sin ITBIS)</div>
          <h3 className="mt-2 mb-0">{money(profitLoss?.revenue)}</h3>
        </Card>
      </Col>
      <Col md={4}>
        <Card className="shadow-sm p-3 dashboard-card">
          <div className="text-muted small">Ganancia Bruta</div>
          <h3 className="mt-2 mb-0" style={{ color: 'var(--mm-green)' }}>{money(profitLoss?.grossProfit)}</h3>
          <div className="text-muted small">margen {pct(profitLoss?.grossMarginPct)}</div>
        </Card>
      </Col>
      <Col md={4}>
        <Card className="shadow-sm p-3 dashboard-card">
          <div className="text-muted small">Ganancia Neta</div>
          <h3 className="mt-2 mb-0" style={{ color: (profitLoss?.netProfit || 0) >= 0 ? 'var(--mm-cyan)' : 'var(--mm-red)' }}>
            {money(profitLoss?.netProfit)}
          </h3>
          <div className="text-muted small">margen {pct(profitLoss?.netMarginPct)}</div>
        </Card>
      </Col>
    </Row>

    <Card className="shadow-sm p-3 mb-3">
      <Card.Title>Estado de Resultados (Simplificado)</Card.Title>
      <Table size="sm" className="mb-0">
        <tbody>
          <tr><td>Ingresos</td><td className="text-end">{money(profitLoss?.revenue)}</td></tr>
          <tr><td>Costo de Ventas (COGS)</td><td className="text-end">({money(profitLoss?.cogs)})</td></tr>
          <tr style={{ fontWeight: 600, borderTop: '1px solid var(--mm-line)' }}>
            <td>Ganancia Bruta</td><td className="text-end">{money(profitLoss?.grossProfit)}</td>
          </tr>
          <tr><td>Gastos Operativos</td><td className="text-end">({money(profitLoss?.operatingExpenses)})</td></tr>
          <tr style={{ fontWeight: 700, borderTop: '2px solid var(--mm-line)' }}>
            <td>Ganancia Neta</td><td className="text-end">{money(profitLoss?.netProfit)}</td>
          </tr>
        </tbody>
      </Table>
    </Card>

    <Row className="mb-3">
      <Col md={6}>
        <Card className="shadow-sm p-3 card-equal-height">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Card.Title className="mb-0">Gastos por Categoría</Card.Title>
            <div style={{ fontWeight: 700, color: 'var(--mm-cyan)' }}>{money(expensesSummary?.total)}</div>
          </div>
          <PagedRows rows={expensesByCategory}>{(rows) => (
            <Table hover size="sm" className="mb-0">
              <thead><tr><th>Categoría</th><th className="text-end"># Gastos</th><th className="text-end">Total</th></tr></thead>
              <tbody>
                {rows.map((e, i) => (
                  <tr key={i}><td>{e.category}</td><td className="text-end">{e.count}</td><td className="text-end">{money(e.total)}</td></tr>
                ))}
                {expensesByCategory.length === 0 && <tr><td colSpan={3} className="text-muted text-center">Sin gastos en este rango.</td></tr>}
              </tbody>
            </Table>
          )}</PagedRows>
        </Card>
      </Col>
      <Col md={6}>
        <Card className="shadow-sm p-3 card-equal-height">
          <Card.Title>Margen Bruto por Producto</Card.Title>
          <PagedRows rows={profitMargin}>{(rows) => (
            <Table hover responsive size="sm" className="mb-0">
              <thead>
                <tr><th>Producto</th><th className="text-end">Cant.</th><th className="text-end">Ingreso</th><th className="text-end">Costo</th><th className="text-end">Margen</th></tr>
              </thead>
              <tbody>
                {rows.map((p, i) => (
                  <tr key={i}>
                    <td>{p.name}</td><td className="text-end">{p.quantity}</td>
                    <td className="text-end">{money(p.revenue)}</td><td className="text-end">{money(p.cogs)}</td>
                    <td className="text-end" style={{ color: p.grossProfit >= 0 ? 'var(--mm-green)' : 'var(--mm-red)' }}>
                      {money(p.grossProfit)} ({pct(p.marginPct)})
                    </td>
                  </tr>
                ))}
                {profitMargin.length === 0 && <tr><td colSpan={5} className="text-muted text-center">Sin datos en este rango.</td></tr>}
              </tbody>
            </Table>
          )}</PagedRows>
        </Card>
      </Col>
    </Row>
  </div>
);

export default GastosTab;
